/**
 * Mirrors Kontent's codename format, e.g.
 *   "Performance Band descriptions" -> "performance_band_descriptions"
 *   "Band 1" -> "band_1"
 */
export const getCodenameFromText = (text?: string): string =>
	(text ?? '')
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, '_')
		.replace(/^_+|_+$/g, '')
